import ProductsLastSeen from '@ui/ProductsLastSeen/component'
import dataLayer, { type DataLayer } from 'assets/core/js/module/dataLayer'
import SnackbarManager from 'assets/core/js/module/snackbarManager'
import { resetCookie } from 'assets/core/js/page/product/lastSeen'

export default (): void => {
  const blockEl = document.querySelector<HTMLElement>('.products-last-seen-block')

  if (!blockEl) {
    return
  }

  const lastSeenEl = blockEl.querySelector<HTMLElement>('.products-last-seen')
  const snackbarEl = document.querySelector<HTMLElement>('#products-last-seen-removed')

  lastSeenEl &&
    ProductsLastSeen(lastSeenEl, {
      onClickResetBtn: () => {
        resetCookie()
        snackbarEl && SnackbarManager.initSnackbar(snackbarEl)
        blockEl.remove()
      },
      onClickProduct: (productSlideElement: HTMLElement) => {
        let data = null
        const rawData = productSlideElement.getAttribute('data-datalayer-click')
        if (rawData !== null) {
          data = JSON.parse<DataLayer>(rawData)
        }
        if (data === null) {
          return
        }

        const event = Object.assign({}, data, {
          page_category: dataLayer.getPageCategory(window.coreGtmId) ?? '',
        })

        dataLayer.pushInLayer(window.coreGtmId, event)
      },
    })
}
